// ** Initial State
const initialState = {
  dropdown: [],
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedGlobalLeaveType: null
}

const GlobalLeaveType = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_GLOBAL_LEAVE_TYPES_DROPDOWN':
      return { ...state, dropdown: action.data }
    case 'GET_ALL_GLOBAL_LEAVE_TYPES':
      return { ...state, allData: action.data }
    case 'FILTER_ALL_GLOBAL_LEAVE_TYPES':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_GLOBAL_LEAVE_TYPE':
      return { ...state, selectedGlobalLeaveType: action.selectedGlobalLeaveType }
    case 'ADD_GLOBAL_LEAVE_TYPE':
      return { ...state }
    case 'DELETE_GLOBAL_LEAVE_TYPE':
      return { ...state }
    default:
      return { ...state }
  }
}
export default GlobalLeaveType
